import { createSpanElement } from './html.funtions';

const PAYMENT_STATES = {
  P: 'Pendiente',
  A: 'Aprobado',
  D: 'Acreditado',
  C: 'Confirmado',
  N: 'Cancelado',
  U: 'Anulado',
  R: 'Rechazado',
  E: 'Error'
};

export function getPaymentState(state: string): string {
  return PAYMENT_STATES[state];
}

export function getHTMLPaymentConcept(cadena: string, imgId: number, type: string) {
  let replaceString: string = null;
  let concepto: string = '';

  if (cadena?.startsWith('Pagado a')) {
    replaceString = 'A';
  }

  if (cadena?.startsWith('Enviado a')) {
    replaceString = 'A';
  }

  if (cadena?.startsWith('Recibido de')) {
    replaceString = 'De';
  }

  if (type == 'OutboundTransaction') {
    if (cadena?.startsWith('Devolución')) {
      replaceString = 'Devolución a';
    }
  } else {
    if (cadena?.startsWith('Devolución')) {
      replaceString = 'Devolución de';
    }
  }

  if (replaceString) {
    var auxText;
    if (replaceString.startsWith('A')) {
      auxText = cadena.slice(replaceString.length + 8);
    } else if (replaceString.startsWith('Devolución')) {
      auxText = cadena.slice(replaceString.length);
    } else {
      auxText = cadena.slice(replaceString.length + 9);
    }
    const spanLabel = createSpanElement('text-label', auxText);
    const span = createSpanElement('sa-center', replaceString + ' ', spanLabel);

    if (imgId) {
      const imgPlaceholder = createSpanElement(`img-loader img-placeholder ${imgId.toString()}`);
      concepto += imgPlaceholder.outerHTML;
    }

    concepto += span.outerHTML;
  } else {
    concepto = cadena;
  }

  return concepto;
}
